import { createAppSyncEventsClient } from './appsyncClient'

function createClient() {
  return createAppSyncEventsClient()
}

export default {
  namespaced: true,
  state: {
    pusher: createClient()
  },
  getters: {
  },
  mutations: {
    setConnect(state) {
      if (state.pusher && typeof state.pusher.disconnect === 'function') {
        state.pusher.disconnect()
      }
      state.pusher = createClient()
    }
  },
  actions: {
    onConnect({ commit }) {
      commit('setConnect')
    }
  }
}
